module.exports = __webpack_public_path__ + "img/833230B2993D150263AC11F9FD6C7C97.833230b2.png";